module.exports = __webpack_public_path__ + "static/media/pentspace.015c595d.png";